import { useRef } from 'react';
import Clipboard from 'clipboard';
import { toast } from "react-toastify";


const CopyButton = ({ content }) => {
  const buttonRef = useRef(null);
  const toastId = useRef(null);
  const handleCopy = (e) => {
    const clipboard = new Clipboard(buttonRef.current, {
      text: () => content
    });

    clipboard.on('success', (e) => {
      // Optionally, you can show a success message or perform any other action here
      console.log('Copied to clipboard!');
      e.clearSelection();
    });

    clipboard.on('error', () => {
      // Optionally, you can handle the error here
      console.error('Failed to copy to clipboard');
    });

    clipboard.onClick(e);
    toastId.current = toast.loading("Text copied...", {
      position: "top-right",
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      autoClose: 2000,
      theme: "colored",
      type: "info"
    });
    setTimeout(() => {
      toast.dismiss( toastId.current);
    }, 1000);
  };

  return (
    <button className="copy-text" ref={buttonRef} onClick={handleCopy}><i className="fa-solid fa-copy" /></button>
  );
};

export default CopyButton;
